import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import {
  getSubVendor,
  patchUpdateSubVendor,
} from "redux/actions/UserSubVendor";
import {
  getDriver,
  patchUpdateDriver,
  postAddDriver,
} from "redux/actions/UserDriver";
import {
  getMoreVehicle,
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from "redux/actions/UserVehicle";
import { getCar } from "redux/actions/UserCar";
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import { getSubVendorRegion } from "redux/actions/UserServiceCity";
import { getChooseYourService } from "redux/actions/UserChooseYourService";
import {
  vehicleDialogData,
  filterStatusVehicle,
} from "pages/vendor/VendorBreadCrumbData";
import CommonDialog from "components/commonDialog/CommonDialog";
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";
import { filterSubVendorData } from "pages/vendor/VendorBreadCrumbData";
import HeaderSubVendor from "./HeaderSubVendor";
import TabSubVendor from "./TabSubVendor";
import SubBreadCrumb from "./SubBreadCrumb";
import {
  editSubVendorDialogData,
  subDriverDialogData,
} from "./SubVendorViewData";
import { commonObject } from 'utils/enumObject';
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { handlePermissions } from "utils/utils";

function SubVendorView() {
  let subVendorStatus = JSON.parse(localStorage.getItem("subVendorStatus"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subVendorDetails = useSelector(
    (state) => state?.userSubVendor?.userSubVendor?.data?.body[0]
  );
  const subVendorDefaultValue = {
    subVendor: subVendorDetails?.companyName,
    name: subVendorDetails?.vendorName,
  };
  const driverData = useSelector(
    (state) => state?.userDriver?.userDriver?.data
  );
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );
  const subVendorMoreData = useSelector(
    (state) => state?.userMoreVehicle?.userMoreVehicle?.data
  );
  const subVendorService = useSelector(
    (state) => state?.userSubVendorRegion?.userSubVendorRegion?.data
  );
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  const loaderDriver = useSelector((state) => state?.userDriver?.loading);
  const loaderVehicle = useSelector((state) => state?.userVehicle?.loading);
  const loaderSubVendor = useSelector((state) => state?.userSubVendor?.loading);
  const loaderSubVendorMoreData = useSelector(
    (state) => state?.userMoreVehicle?.loading
  );
  const loaderSubVendorServiceArea = useSelector(
    (state) => state?.userSubVendorRegion?.loading
  );
  const loaderSubVendorService = useSelector(
    (state) => state?.userSubVendorRegion?.loading
  );

  const { state } = useLocation();
  const { subVendorId, name, companyId, cityLocation } = state;
  const tabType = state?.tabType;
  const [formData, setFormData] = useState(subDriverDialogData);
  const [type, setType] = useState("Driver");
  const [subButtonText, setSubButtonText] = useState("Driver +");
  const [tableData, setTableData] = useState(driverData);
  const [value, setValue] = useState("1");
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [iconType, setIconType] = useState("Edit");
  const [iconId, setIconId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [complianceOpen, setComplianceOpen] = useState(false);
  const [status, setStatus] = useState(
    subVendorStatus?.length > 0 ? subVendorStatus : ""
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterLocation, setFilterLocation] = useState("");
  const [search, setSearch] = useState("");
  let filterDataDriver = {
    id: companyId,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: "subVendor",
    search: search,
  };

  let filterDataVehicle = {
    id: companyId,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: "subVendor",
    search: search,
  };

  let filterData = {
    subVendorId: subVendorId,
    status: "",
    page: "",
    pageSize: "",
    date: "",
  };

  const subVendorData = {
    submitterId: companyId,
    submitterType: "company",
  };
  const data = {
    id: companyId,
    type: "Company",
  };

  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  useEffect(() => {
    dispatch(getSubVendor(filterData));
    dispatch(getDriver(filterDataDriver));
    dispatch(getCar());
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  useEffect(() => {
    if (type === "Driver") {
      setTableData(driverData);
    } else if (type === "Vehicle") {
      setTableData(vehicleData);
    }
  }, [driverData, vehicleData]);

  const handleTabChange = (newValue) => {
    localStorage.removeItem("subVendorStatus");
    setValue(newValue);
    setPage(0);
    setStatus([]);
    onRestFilter();
    if (newValue === "1") {
      setSubButtonText("Driver +");
      setType("Driver");
      setFormData(subDriverDialogData);
      dispatch(getDriver({ ...filterDataDriver, status: "" }));
      setTableData(driverData);
    } else if (newValue === "2") {
      setSubButtonText("Vehicle +");
      setType("Vehicle");
      setFormData(vehicleDialogData(carOption));
      dispatch(getVehicle({ ...filterDataVehicle, status: "" }));
      setTableData(vehicleData);
    } else if (newValue === "3") {
      dispatch(getMoreVehicle(subVendorData));
      dispatch(getSubVendorRegion(subVendorData));
      dispatch(getChooseYourService(data));
      setSubButtonText("");
      setSearch("");
    } else {
      setSubButtonText("");
    }
  };

  const onClickTable = (val) => {
    localStorage.setItem("subVendorStatus", JSON.stringify(status));
    let url = window.location.pathname.split("/")[2];
    let urlvendor = window.location.pathname.split("/")[1];
    if (url === "subvendor") {
      if (value === "2") {
        navigate("/vendor/subvendor/vehicle", {
          state: {
            vehicleId: val?.id,
            status: val?.status,
            name: val?.carModel,
            cityLocation: cityLocation,
            subVendorName: name,
          },
        });
      } else if (value === "1") {
        navigate("/vendor/subvendor/driver", {
          state: {
            driverId: val?.id,
            status: val?.status,
            name: val?.name,
            id: val?.authId,
            cityLocation: cityLocation,
            subVendorName: name,
          },
        });
      }
    } else if (urlvendor === "subvendor") {
      if (value === "2") {
        navigate("/subvendor/vehicle", {
          state: {
            vehicleId: val?.id,
            status: val?.status,
            name: val?.carModel,
            subVendorName: name,
          },
        });
      } else if (value === "1") {
        navigate("/subvendor/driver", {
          state: {
            driverId: val?.id,
            status: val?.status,
            name: val?.name,
            id: val?.authId,
            subVendorName: name,
          },
        });
      }
    }
  };

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    if (type === "Vehicle") {
      const data = {
        ...val,
        carType: "COC",
        seating: parseInt(val?.seating),
        id: companyId,
        type: "subVendor",
        avtar: selectedImage,
      };
      let formData = new FormData();

      Object.keys(data).map((val) => {
        formData.append(val, data[val]);
      });
      dispatch(postAddVehicle(formData));
      setShowOtherComponent(true);
    } else {
      const data = {
        mobile: val.number,
        firstName: val.driverName,
        lastName: "",
        altmobile: val.mobile,
        DOB: val.birthday,
        permanentaddress: val.permanentaddress,
        currentaddress: val.currentaddress,
        covid: val.covid,
        email: val.email,
        countryCode: code,
        parentId: companyId,
        subVendorId: subVendorId,
        companyName: val.driverName + val.number,
      };
      dispatch(postAddDriver(data));
    }
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const onEditProfile = (data, code) => {
    const profileData = {
      subVendorId: subVendorId,
      data: {
        firstName: data?.name,
        lastName: "",
        email: data?.email,
        countryCode: "+91",
        mobile: data?.number,
        companyName: data?.name,
        location: data?.address,
      },
    };
    dispatch(patchUpdateSubVendor(profileData));
  };

  const onClickMoreIcon = (data, iconType) => {
    if (type === "Driver") {
      const value = {
        vendorName: type === "Driver" ? data?.name : data?.companyName,
        email: data?.email,
        number: data?.mobile,
        birthday: data?.birthday,
        address: data?.location,
        driverName: data?.name,
        subVendor: data?.subVendorName,
        name: data?.vendorName,
      };
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === "Edit") {
        setIconType(iconType);
        setOpen(true);
      }
     else if (iconType === "Upload Compliance") {
      setIconType(iconType);
      setComplianceOpen(true);

      const profileData = {
        driverId: data.id,
        type: "driverRegistration",
      };

      setShowOtherComponent(true);
      dispatch(getOnBoardCompliance(profileData));
    }
    else if (iconType === "Deactivate") {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "InActive",
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === "Activate") {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === "Block") {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Blocked",
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      } else if (iconType === "Unblock") {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(
          patchUpdateDriver({ ...profileData, parentId: state?.companyId })
        );
      }
    } else if (type === "Vehicle") {
      const value = { ...data };
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === "Edit") {
        setIconType(iconType);
        setOpen(true);
      } else if (iconType === "Activate") {
        const profileData = {
          id: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(patchUpdateVehicle(profileData));
      } else if (iconType === "Block") {
        const profileData = {
          id: data.id,
          data: {
            status: "Blocked",
          },
        };
        dispatch(patchUpdateVehicle(profileData));
      } else if (iconType === "Unblock") {
        const profileData = {
          id: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(patchUpdateVehicle(profileData));
      } else if (iconType === "Upload Compliance") {
        setIconType(iconType);
        setOpen(true);
        const profileData = {
          vehicleId: data.id,
          type: "vehicleRegistration",
        };
        setShowOtherComponent(true);
        dispatch(getOnBoardCompliance(profileData));
      } else if (iconType === "Deactivate") {
        const profileData = {
          isApproved: "InActive",
          id: data?.id,
        };
        dispatch(
          patchUpdateVehicle({ ...profileData, subVendorId: state?.companyId })
        );
      } else if (iconType === "Activate") {
        const profileData = {
          isApproved: "Active",
          id: data?.id,
        };
        dispatch(
          patchUpdateVehicle({ ...profileData, subVendorId: state?.companyId })
        );
      }
    }
  };

  const onDialog = (data, code) => {
    if (type === "Sub Vendor") {
      const profileData = {
        subVendorId: iconId,
        id: subVendorId,
        data: {
          firstName: data?.vendorName,
          lastName: "",
          email: data?.email,
          countryCode: "+91",
          mobile: data?.number,
          number: data?.mobile,
          companyName: data?.vendorName,
          location: data?.address,
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (type === "Driver") {
      const profileData = {
        driverId: iconId,
        parentId: companyId,
        data: {
          firstName: data?.driverName,
          lastName: "",
          email: data?.email,
          countryCode: "+91",
          mobile: data?.number,
          number: data?.mobile,
          companyName: "",
          location: data?.address,
        },
      };
      dispatch(patchUpdateDriver(profileData));
    } else if (type === "Vehicle") {
      const vehicleData = {
        ...data,
        carType: "COC",
        seating: parseInt(data?.seating),
        id: iconId,
        type: "subVendor",
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(vehicleData).map((val) => {
        formData.append(val, vehicleData[val]);
      });
      dispatch(patchUpdateVehicle(formData));
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setIconType("");
    setShowOtherComponent(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (value === "1") {
      dispatch(getDriver({ ...filterDataDriver, page: newPage }));
    } else if (value === "2") {
      dispatch(getVehicle({ ...filterDataVehicle, page: newPage }));
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    if (value === "1") {
      dispatch(
        getDriver({
          ...filterDataDriver,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    } else if (value === "2") {
      dispatch(
        getVehicle({
          ...filterDataVehicle,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    }
  };

  const onFilterChange = (val) => {
    localStorage.removeItem("subVendorStatus");
    setPage(0);
    const defaultStatus = [
      "Active",
      "InActive",
      "Blocked",
      "Pending",
      "Rejected",
    ];

    const filterLocations = val.filter((location) => {
      return !defaultStatus.includes(location);
    });

    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus);
    setFilterLocation(filterLocations);

    if (value === "1") {
      const driverFilterData = {
        ...filterDataDriver,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getDriver(driverFilterData));
    } else if (value === "2") {
      const vehicleFilterData = {
        ...filterDataVehicle,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  const onRestFilter = () => {
    localStorage.removeItem("subVendorStatus");
    setStatus("");
    if (value === "1") {
      const driverFilterData = {
        ...filterDataDriver,
        status: "",
      };
      dispatch(getDriver(driverFilterData));
    } else if (value === "2") {
      const vehicleFilterData = {
        ...filterDataVehicle,
        status: "",
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  const onSearch = debounce((e) => {
    setSearch(e);
    setPage(0);
    if (value == "1") {
      const searchFilterData = {
        ...filterDataDriver,
        search: e,
        page: 0,
      };
      dispatch(getDriver(searchFilterData));
    } else if (value === "2") {
      const searchFilterData = {
        ...filterDataVehicle,
        search: e,
        page: 0,
      };
      dispatch(getVehicle(searchFilterData));
    }
  }, 1000);

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };
  //for header Icon actions

  const onClickStatusIcon = (data) => {
    setDefaultValue(value);
    setIconId(data.id);

    if (data === "Deactivate") {
      const profileData = {
        subVendorId: subVendorId,
        data: {
          status: "InActive",
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === "Activate") {
      const profileData = {
        subVendorId: subVendorId,
        data: {
          status: "Active",
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === "Block") {
      const profileData = {
        subVendorId: subVendorId,
        data: {
          status: "Blocked",
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (data === "Unblock") {
      const profileData = {
        subVendorId: subVendorId,
        data: {
          status: "Active",
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    }
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const subVendorRoleEnum = roleAndPermissionEnum.subvendor
  const cityManagerRoleEnum = roleAndPermissionEnum.citymanager

  const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

  const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});
  const accessForOnlyView = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorView});
  const accessForOnlyEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorEdit});
  const accessForOnlyActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorActivate});

  const accessForOnlyBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorBlock});

  const accessForOnlyAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.subVendorAdd});

  const accessForSubVendorDriverEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.editDriver});
  const accessForSubVendorDriverActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.activateDriver});

  const accessForSubVendorVehicleBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockVehicel});

  const accessForSubVendorVehicleEdit = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.editVehicle});

  const accessForSubVendorDriverBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockDriver});

  const viewMoreIconDriver = (accessCityManagerForAdd || accessForAdd || accessForSubVendorDriverEdit || accessForSubVendorDriverActivate||accessForSubVendorDriverBlock )
  const addButton = (accessCityManagerForAdd || accessForAdd ||accessForOnlyAdd )

  const editButton = (accessCityManagerForAdd ||accessForAdd || accessForOnlyEdit)
  const statusChange = (accessCityManagerForAdd || accessForAdd ||accessForOnlyActivate || accessForOnlyBlock )

  const viewMoreIconVehicle = (accessCityManagerForAdd || accessForAdd || accessForSubVendorVehicleEdit || accessForSubVendorVehicleBlock )

  return (
    <div>
      <SubBreadCrumb
        subButtonText={addButton && subButtonText}
        formData={formData}
        type={type}
        onSubmittBtn={onSubmit}
        name={name}
        defaultValues={subVendorDefaultValue}
        setSelectedImage={selectedImage}
        onImageChange={onImageChange}
        showOtherComponent={showOtherComponent}
        closeUploadCompliance={closeUploadCompliance}
        cityLocation={cityLocation}
        tabType={tabType}
      />
      <HeaderSubVendor
        type={"Sub-Vendor"}
        editData={editSubVendorDialogData(subVendorDetails)}
        onSubmittBtn={onEditProfile}
        details={subVendorDetails}
        onClickStatusIcon={onClickStatusIcon}
        loader={loaderSubVendor}
        editButton={!editButton} 
        statusChange={statusChange}
      />
      <TabSubVendor
        defaultStatus={status}
        onTabChange={handleTabChange}
        tableData={tableData}
        onClickTable={onClickTable}
        value={value}
        onClickMoreIcon={onClickMoreIcon}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        filterdata={
          type === "Vehicle" ? filterStatusVehicle : filterSubVendorData
        }
        subVendorMoreDetails={subVendorMoreData}
        subVendorLocation={subVendorService}
        chooseYourServiceData={chooseYourServiceData}
        onSearch={onSearch}
        loaderDriver={loaderDriver}
        loaderVehicle={loaderVehicle}
        loaderSubVendorMoreData={loaderSubVendorMoreData}
        loaderSubVendorServiceArea={loaderSubVendorServiceArea}
        loaderSubVendorService={loaderSubVendorService}
      />

      {open && iconType === "Edit" ? (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          type={"Edit " + type + " "}
          selectType={"edit"}
          defaultValues={defaultValue}
        />
      ) : null}

      {type === "Vehicle" && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"edit"}
          type={'Upload Vehicle Compliance' }
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={iconId}
        />
      )}
          
      {type === "Driver" && complianceOpen && (
        <CommonMultiImageForm
          open={complianceOpen}
          handleClose={() => {
            setComplianceOpen(false);
            setShowOtherComponent(false);
          }}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'edit'}
          type={'Upload Driver Compliance'}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="driver"
          driverId={iconId}
        />
      )}
    </div>
  );
}

export default SubVendorView;
